import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerSubscriber extends AManagerApi {
    protected _url: string = '/owner/subscriber';
}
